export const savePosIdLocalStorage = (currentSelected) => {
  return localStorage.setItem('pdvSelected', JSON.stringify(currentSelected)) ;
};
